'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
}

interface TrendingQuestionsProps {
  faqs: FAQ[];
  language: 'en' | 'ar';
}

const TrendingQuestions = ({ faqs, language }: TrendingQuestionsProps) => {
  return (
    <section className="py-12 bg-gradient-to-r from-accent/10 to-brand-purple/10 border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-6">
          <Icon name="FireIcon" size={24} variant="solid" className="text-accent" />
          <h2 className="text-2xl lg:text-3xl font-headline font-bold text-text-primary">
            {language === 'en' ? 'Trending Questions' : 'الأسئلة الشائعة'}
          </h2>
        </div>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-card rounded-lg p-4 shadow-soft hover:shadow-elevated transition-shadow duration-base border border-border"
            >
              <div className="flex items-start gap-3">
                <Icon name="QuestionMarkCircleIcon" size={20} variant="solid" className="text-primary flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm font-semibold text-text-primary mb-1">{faq.question}</p>
                  <p className="text-xs text-text-secondary">{faq.category}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingQuestions;